<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-9">
                <div class="row">

                    <div class="col-md-12">
                        <app-sub-header title="Faq"></app-sub-header>


                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="min-height">
                            <div *ngIf="!loading" class="accordion" id="accordionExample">
                                <div class="card" *ngFor="let props of arr; let i = index">

                                    <div class="card-header" id="heading{{i}}">
                                        <h2 class="mb-0">
                                            <button class="btn btn-block text-left" type="button" data-toggle="collapse"
                                                attr.data-target="#collapse{{i}}" aria-expanded="true"
                                                aria-controls="collapse{{i}}">
                                                <app-skelton></app-skelton>
                                            </button>
                                        </h2>
                                    </div>

                                    <div id="collapse{{i}}" class="collapse " aria-labelledby="heading{{i}}"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            <app-skelton></app-skelton>
                                        </div>
                                    </div>
                                </div>


                            </div>




                            <div *ngIf="loading" class="accordion" id="accordionExample">
                                <div class="card" *ngFor="let props of (faqarr | paginate
                            : {
                                itemsPerPage: pageSize,
                                currentPage: pageNo,
                                totalItems: totalItems
                              }); let i = index">

                                    <div class="card-header" id="heading{{i}}">
                                        <h2 class="mb-0">
                                            <button class="btn btn-block text-left" type="button" data-toggle="collapse"
                                                attr.data-target="#collapse{{i}}" aria-expanded="true"
                                                aria-controls="collapse{{i}}">
                                                {{props.question}}
                                                <i style="float: right;" class="fas fa-arrow-right text-right"></i>
                                            </button>

                                        </h2>

                                    </div>

                                    <div id="collapse{{i}}" class="collapse " aria-labelledby="heading{{i}}"
                                        data-parent="#accordionExample">
                                        <div class="card-body">
                                            {{props.answer}}}
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                        <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                            <!-- <app-pagination [maxSize]="pageSize" (pageChange)="page = onChange($event)"></app-pagination> -->
                            <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                                *ngIf="faqarr?.length > 0 " (pageChange)="page = getFaq($event)" directionLinks="true"
                                autoHide="false" responsive="true" previousLabel="Previous" nextLabel="Next"
                                screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                                screenReaderCurrentLabel="You're on page">
                            </pagination-controls>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<router-outlet></router-outlet>